// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/support/v1/ticket.proto (package gportal.api.support.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { SupportCategory, SupportCategoryServer } from "./support_infos_pb.js";
import { SupportAddon } from "./support_addons_pb.js";
import { SupportMessage } from "./support_message_pb.js";

/**
 * @generated from enum gportal.api.support.v1.TicketMessageRating
 */
export enum TicketMessageRating {
  /**
   * @generated from enum value: TICKET_MESSAGE_RATING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TICKET_MESSAGE_RATING_NEGATIVE = 1;
   */
  NEGATIVE = 1,

  /**
   * @generated from enum value: TICKET_MESSAGE_RATING_POSITIVE = 2;
   */
  POSITIVE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(TicketMessageRating)
proto3.util.setEnumType(TicketMessageRating, "gportal.api.support.v1.TicketMessageRating", [
  { no: 0, name: "TICKET_MESSAGE_RATING_UNSPECIFIED" },
  { no: 1, name: "TICKET_MESSAGE_RATING_NEGATIVE" },
  { no: 2, name: "TICKET_MESSAGE_RATING_POSITIVE" },
]);

/**
 * @generated from enum gportal.api.support.v1.TicketStatus
 */
export enum TicketStatus {
  /**
   * @generated from enum value: TICKET_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TICKET_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: TICKET_STATUS_CLOSED = 2;
   */
  CLOSED = 2,

  /**
   * @generated from enum value: TICKET_STATUS_ANSWERED = 4;
   */
  ANSWERED = 4,

  /**
   * @generated from enum value: TICKET_STATUS_FOLLOWUP = 8;
   */
  FOLLOWUP = 8,

  /**
   * @generated from enum value: TICKET_STATUS_PENDING = 16;
   */
  PENDING = 16,
}
// Retrieve enum metadata with: proto3.getEnumType(TicketStatus)
proto3.util.setEnumType(TicketStatus, "gportal.api.support.v1.TicketStatus", [
  { no: 0, name: "TICKET_STATUS_UNSPECIFIED" },
  { no: 1, name: "TICKET_STATUS_OPEN" },
  { no: 2, name: "TICKET_STATUS_CLOSED" },
  { no: 4, name: "TICKET_STATUS_ANSWERED" },
  { no: 8, name: "TICKET_STATUS_FOLLOWUP" },
  { no: 16, name: "TICKET_STATUS_PENDING" },
]);

/**
 * TicketSource identifies which backend a ticket originates from. The website merges legacy and
 * Intercom tickets into one list; the UI uses this to label/branch rendering without parsing the id.
 *
 * @generated from enum gportal.api.support.v1.TicketSource
 */
export enum TicketSource {
  /**
   * @generated from enum value: TICKET_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TICKET_SOURCE_LEGACY = 1;
   */
  LEGACY = 1,

  /**
   * @generated from enum value: TICKET_SOURCE_INTERCOM = 2;
   */
  INTERCOM = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(TicketSource)
proto3.util.setEnumType(TicketSource, "gportal.api.support.v1.TicketSource", [
  { no: 0, name: "TICKET_SOURCE_UNSPECIFIED" },
  { no: 1, name: "TICKET_SOURCE_LEGACY" },
  { no: 2, name: "TICKET_SOURCE_INTERCOM" },
]);

/**
 * @generated from message gportal.api.support.v1.Ticket
 */
export class Ticket extends Message<Ticket> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: gportal.api.support.v1.TicketStatus status = 3;
   */
  status = TicketStatus.UNSPECIFIED;

  /**
   * @generated from field: gportal.api.support.v1.SupportCategory category = 4;
   */
  category?: SupportCategory;

  /**
   * @generated from field: optional gportal.api.support.v1.SupportAddon addon = 5;
   */
  addon?: SupportAddon;

  /**
   * @generated from field: optional gportal.api.support.v1.SupportCategoryServer server = 6;
   */
  server?: SupportCategoryServer;

  /**
   * @generated from field: bool is_closeable = 7;
   */
  isCloseable = false;

  /**
   * source identifies whether this ticket lives in the legacy web-interface DB or in Intercom.
   *
   * @generated from field: gportal.api.support.v1.TicketSource source = 8;
   */
  source = TicketSource.UNSPECIFIED;

  /**
   * @generated from field: repeated gportal.api.support.v1.SupportMessage messages = 14;
   */
  messages: SupportMessage[] = [];

  /**
   * @generated from field: optional google.protobuf.Timestamp closed = 100;
   */
  closed?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp answered = 101;
   */
  answered?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp asked = 102;
   */
  asked?: Timestamp;

  /**
   * ISO 8601 format
   *
   * @generated from field: optional google.protobuf.Timestamp email_notified = 103;
   */
  emailNotified?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp created = 1000;
   */
  created?: Timestamp;

  constructor(data?: PartialMessage<Ticket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.Ticket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(TicketStatus) },
    { no: 4, name: "category", kind: "message", T: SupportCategory },
    { no: 5, name: "addon", kind: "message", T: SupportAddon, opt: true },
    { no: 6, name: "server", kind: "message", T: SupportCategoryServer, opt: true },
    { no: 7, name: "is_closeable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "source", kind: "enum", T: proto3.getEnumType(TicketSource) },
    { no: 14, name: "messages", kind: "message", T: SupportMessage, repeated: true },
    { no: 100, name: "closed", kind: "message", T: Timestamp, opt: true },
    { no: 101, name: "answered", kind: "message", T: Timestamp, opt: true },
    { no: 102, name: "asked", kind: "message", T: Timestamp, opt: true },
    { no: 103, name: "email_notified", kind: "message", T: Timestamp, opt: true },
    { no: 1000, name: "created", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Ticket {
    return new Ticket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Ticket {
    return new Ticket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Ticket {
    return new Ticket().fromJsonString(jsonString, options);
  }

  static equals(a: Ticket | PlainMessage<Ticket> | undefined, b: Ticket | PlainMessage<Ticket> | undefined): boolean {
    return proto3.util.equals(Ticket, a, b);
  }
}

